import "../Page/Home.css"
import insta from "../img/insta.png"
import facebook from "../img/facebook.png"
import mail from "../img/mail.png"
import { Link } from "react-router-dom";



function Home(){
    return (
        <div className="homePage">
            <div className="Section-One">
                <div className="division1">
                    <div className="subdivision">
                    <h1 className="word tagline">3D thinking</h1>
                    <div className="subdivision1">
                    <h2 className="word subtagline">Decide.</h2>
                    <h2 className="word subtagline">Debate.</h2>
                    <h2 className="word subtagline">Develop.</h2>
                    </div>
                    </div>
                    <div className="subdivision2">
                    <p className="guide">
                        Guided by our tagline "Decide. Debate. Develop.", we create a space where students make informed choices, engage in powerful discussions, and grow into confident, solution-driven leaders. At Unisfera MUN, it's all about building skills that go beyond the committee room.  
                    </p>
                    </div>
                </div>
                <div className="person">
                    <div className="poster"></div>

                </div>
            </div>
            <div className="Section-Two">
                <div className=""></div>
                <div className="adsholder">
                    <Link to="/events" className="ads"></Link>
                    <Link to="/events" className="ads"></Link>
                </div>
                <div className="aboutus">
                    <div className="glow"></div>
                    <div className="glow1"></div>
                    <div className="section2para">
                         <div className="mainparasection">
                            <div className="card">
                                <div className="section2paratitle">Who We Are?</div>
                                <div className="parapart">Unisfera MUN is a student-led platform founded 
                                    by five classmates who shared a vision of creating something 
                                    more personal, impactful, and accessible than the typical 
                                    large-scale MUNs. We built Unisfera to give students 
                                    a consistent, welcoming space to grow as leaders 
                                    and global thinkers. Our name reflects our mission, Uni for unity and 
                                    sfera for sphere, symbolizing a world where youth come together to 
                                    foster meaningful change.
                                </div>
                            </div>
                            <div className="card">
                                <div className="section2paratitle">What We Do?</div>
                                    <div className="parapart"> We host recurring Model 
                                    United Nations conferences every one to two months, featuring a
                                    full range of committees, from the UNHRC and WHO to 
                                    morelocalized or crisis-based councils. Whether you're a 
                                    seasoned delegate or completely new to MUNs, Unisfera welcomes all. 
                                    Our goal is to create a space that balances structure and inclusivity, 
                                    where first-timers can learn confidently, and experienced participants 
                                    can challenge themselves. 
                                </div>
                            </div>
                            <div className="card">
                            <div className="section2paratitle">Who Can Join?</div>
                            <div className="parapart">Each event includes opportunities for 
                                competitive debates, critical discussions, and awards, with prize money 
                                for the top performers in each committee. While our conferences are 
                                currently held online, we aim to expand into offline formats and broader 
                                academic events in the near future. At its core, Unisfera MUN stands for 
                                the overall growth of youth, nurturing leadership, confidence, and global 
                                wareness through meaningful experiences.
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="information">
                    <div className="links">
                        <a href="https://www.instagram.com/unisfera_mun/"><img src={insta} alt="insta" className="image insta"></img></a>
                        <a href="https://www.facebook.com/"><img src={facebook} alt="facebook" className="image facebook"></img></a>
                        <a href="mailto:unisferamodelunitednations@gmail.com"><img src={mail} alt="mail" className="image mail"></img></a>
                        
                    </div>
                    <div className="copyright">© 2025 Unisfera, Inc. All Rights Reserved.</div>
                    </div>
            </div>
        </div>
    )
}

export default Home;